/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Asiframe2Inputs */

const en_entity_asiframe2 = /** @type {(inputs: Entity_Asiframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As iFrame`)
};

const de_entity_asiframe2 = /** @type {(inputs: Entity_Asiframe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als iFrame`)
};

/**
* | output |
* | --- |
* | "As iFrame" |
*
* @param {Entity_Asiframe2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_asiframe2 = /** @type {((inputs?: Entity_Asiframe2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Asiframe2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_asiframe2(inputs)
	return de_entity_asiframe2(inputs)
});
export { entity_asiframe2 as "entity_asIFrame" }